import * as React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import * as FieldStyles from './UrlField.scss';

/**
 * @public
 */
export interface IUrlFieldProps {
  url: string;
  urlDisplay: string;
  ariaLabel?: string;
  isImageUrl?: boolean;
  onClick?: (ev: React.MouseEvent<HTMLElement>) => void;
  isFolder?: boolean;
}

/**
 * @public
 */
export const UrlField: React.StatelessComponent<IUrlFieldProps> = (props: IUrlFieldProps) => {
  let { url, urlDisplay, ariaLabel, isImageUrl, isFolder, onClick } = props;
  ariaLabel = ariaLabel || urlDisplay;

  if (!url) {
    return null; // save dom elements for empty column
  }

  if (!urlDisplay) {
    urlDisplay = url;
  }

  if (!isFolder || !onClick) {
    onClick = (evt: React.MouseEvent<HTMLElement>) => {
      if (Boolean(evt) && Boolean(evt.target)) {
        if (Boolean(url)) {
          window.open(url, '_blank');
        }
      }
    };
  }

  return (
    isFolder ? (
      <Link
        data-automationid='FieldRenderer-url'
        href={ urlDisplay }
        onDragStart={ preventDefault }
        onClick={ onClick }
        title={ urlDisplay }
      >
        { urlDisplay }
      </Link>
    ) :
      (isImageUrl ?
        (
          <div
            data-automationid='FieldRenderer-url'
            className={ `${FieldStyles.image}` }
            data-is-focusable='true'
            onClick={ onClick }
          >
            <img src={ url } title={ urlDisplay } className={ `${FieldStyles.imageDisplay}` } />
          </div>
        )
        :
        (
          <Link
            data-automationid='FieldRenderer-url'
            className={ `${FieldStyles.urlField}` }
            href={ url }
            onDragStart={ preventDefault }
            title={ urlDisplay }
            target='_blank'
          >
            { urlDisplay }
          </Link>
        )
      )
  );
};

function preventDefault(event: React.DragEvent<HTMLElement>): void {
  event.preventDefault();
}
